import { loadScript } from './loadScripts'

let loadPromise = null

/**
 * 单例加载 Google Maps JS SDK
 * @param {Object} opts
 * @param {string} opts.apiKey
 * @param {string[]} [opts.libraries] 默认 ['marker']
 * @param {string} [opts.language] 强制 UI 语言（默认 'en'）
 * @param {string} [opts.region]
 * @returns {Promise<typeof window.google>}
 */
export function loadGoogleMaps({
  apiKey,
  libraries = ['marker'],
  language = 'en',
  region,
} = {}) {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Maps cannot be loaded on server'))
  }
  if (!apiKey) {
    return Promise.reject(new Error('Google Maps API key is missing'))
  }
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google)
  }
  if (loadPromise) return loadPromise

  // 不使用 loading=async：经典加载模式下 onload 触发时 google.maps.Map / marker 子库立即可用
  // 而 loading=async 模式需要使用 inline bootstrap loader + importLibrary，与 loadScript 不兼容
  const params = new URLSearchParams({
    key: apiKey,
    v: 'weekly',
    libraries: libraries.join(','),
    language,
  })
  if (region) params.append('region', region)

  loadPromise = loadScript({
    src: `https://maps.googleapis.com/maps/api/js?${params.toString()}`,
  }).then(() => {
    if (!window.google || !window.google.maps) {
      loadPromise = null
      throw new Error('Google Maps SDK loaded but window.google.maps is missing')
    }
    return window.google
  }).catch((err) => {
    loadPromise = null
    throw err
  })

  return loadPromise
}
